var path = 'dashboard/states/default-state-controller.tpl.html';
var html = "\n<md-select class=\"default-state-controller\" ng-show=\"vm.displayStateSelection()\" aria-label=\"{{ 'dashboard.state' | translate }}\" ng-model=\"vm.stateObject[0].id\">\n    <md-option ng-repeat=\"(stateId, state) in vm.states\" ng-value=\"stateId\">\n        {{vm.getStateName(stateId, state)}}\n    </md-option>\n</md-select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/states/default-state-controller.tpl.html
// module id = 1442
// module chunks = 1